import { type ForwardedRef, forwardRef } from 'react';
import { RootComponent } from '../../../../services/root-component';
import { LayoutProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef(function Component<T>(
  { Component = 'section', header, children, ...props }: LayoutProps<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <RootComponent
      {...props}
      Component={Component}
      baseClassName={css.host}
      ref={forwardedRef}
    >
      {header}

      {children}
    </RootComponent>
  );
});
